// extracted by mini-css-extract-plugin
export default {"container":"Yi-z","links":"Zi-z"};